import React, { useEffect } from "react";
import PageHeader from "../../components/shared/pageHeader/PageHeader";
import { useTranslation } from "react-i18next";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {
}

const TutorialsView = ({ ...restProps }: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------
  // Access to i18n instance that you may use to translate your content.
  const { t } = useTranslation();

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------
  /**
   * This method is called the first time the component is mounted
   * @function
   */
  const init = (): void => {
    // init component
    console.log("[TutorialsView] init");
  };

  /**
   * This method is called when the component is unmounted
   * @function
   */
  const destroy = (): void => {
    // destroy component
    console.log("[TutorialsView] destroy");
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This hook is called once when the component is mounted
   */
  useEffect(() => {
    init();
    return () => {
      destroy();
    };
  }, []);

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return (
    <>
      {/* <Navbar/> */}
      <div className="main-content">
        <div className="container">
          <PageHeader title={t("pages.tutorials.title")}/>
          <div className="page-content" id={"tutorials"}>
            <div className={"row"}>
              <div className="col-xs-12 col-sm-6">
                <h4>{t("pages.tutorials.preregistrationDone.title")}</h4>
                <p>{t("pages.tutorials.preregistrationDone.description")}</p>
                <br/>
                <iframe src="https://www.youtube.com/embed/4FEPQq0omVw"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen/>
              </div>
              <div className="col-xs-12 col-sm-6">
                <h4>{t("pages.tutorials.notRegisteredYet.title")}</h4>
                <p>{t("pages.tutorials.notRegisteredYet.description")}</p>
                <br/>
                <iframe src="https://www.youtube.com/embed/P6tXub27FDk"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen/>
              </div>
            </div>
            <br/><hr/><br/>
            <div className={"row"}>
              <div className="col-xs-12 col-sm-6">
                <h4>{t("pages.tutorials.enableChat.title")}</h4>
                <p>{t("pages.tutorials.enableChat.description")}</p>
                <br/>
                <iframe src="https://www.youtube.com/embed/0UOvTUP7R5A"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen/>
              </div>
              <div className="col-xs-12 col-sm-6">
                <h4>{t("pages.tutorials.surfPlatform.title")}</h4>
                <p>{t("pages.tutorials.surfPlatform.description")}</p>
                <br/>
                <iframe src="https://www.youtube.com/embed/bWs0iVewk2M"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default TutorialsView;
